import { render } from "./GoalRow.vue?vue&type=template&id=7d390a63"
import script from "./GoalRow.vue?vue&type=script&lang=js"
export * from "./GoalRow.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__